import { DRAG_ELEMENT, RESIZE } from './mutation-types'

export default {
  [DRAG_ELEMENT]: (state, { x, y, height, width }) => {
    state.mainSectionPosition.left = x
    state.mainSectionPosition.top = y
    state.mainSectionPosition.height = height
    state.mainSectionPosition.width = width
  },

  [RESIZE]: state => {
    state.screenWidth = window.innerWidth
    state.screenHeight = window.innerHeight

    if (state.screenWidth > state.mainSectionPosition.width) {
      state.mainSectionPosition.width = state.screenWidth - 230
    }

    if (state.screenHeight > state.mainSectionPosition.height) {
      state.mainSectionPosition.height = state.screenHeight - 280
    }
  },
}
